import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { Icon, TIconName, IconButton, TIconButtonProps } from '@treezor/design-system';

export interface IItemGroup {
  label: ReactNode;
  actions: Pick<TIconButtonProps, 'icon' | 'onClick'>[];
  leftIcon?: TIconName;
  itemGroupType?: ReactNode;
}

export function ItemGroup({ leftIcon, label, itemGroupType, actions, className }: IItemGroup & { className?: string }) {
  return (
    <div className={twMerge('py-0 px-4.5 flex gap-5 justify-between', className)}>
      <div className={clsx('flex gap-3', typeof label === 'string' && 'items-center')}>
        {leftIcon && <Icon name={leftIcon} isFill={false} size="s" className="text-icon-info" />}
        <div className="text-secondary typo-body-regular-small">{label}</div>
      </div>
      <div className="flex gap-5 items-center">
        {typeof itemGroupType === 'string' ? (
          <span className="text-tertiary typo-body-regular-caption">{itemGroupType}</span>
        ) : (
          itemGroupType
        )}
        <div className="flex">
          {actions.map((action, index) => (
            <IconButton {...action} variant="secondary" size="s" key={`action-${index}`} />
          ))}
        </div>
      </div>
    </div>
  );
}
